/**
 * Auth convenience hook.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../store/authStore";

export default function useAuth({ requireAuth = true, requiredRoles = [] } = {}) {
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (isLoading) return;

    if (requireAuth && !isAuthenticated) {
      navigate("/login");
      return;
    }

    if (requiredRoles.length > 0 && user && !requiredRoles.includes(user.role)) {
      navigate("/dashboard");
    }
  }, [isLoading, isAuthenticated, user, requireAuth, requiredRoles, navigate]);

  return { user, isAuthenticated, isLoading };
}
